import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import FieldWrapper from '@/forms/FormElements/Common/FieldWrapper/FieldWrapper.vue';
import ErrorWrapper from '@/forms/FormElements/Common/ErrorWrapper/ErrorWrapper.vue';

import RowValidationMixin from '@/forms/FormElements/Mixins/RowValidationMixin';
import SelectItem from '@/common/interfaces/SelectItem';

import CtaButton from '@/components/CtaButton/CtaButton.vue';
import CtaLinkItem, { CtaButtonStyle } from '@/common/interfaces/CtaLinkItem';

@Component({ components: { CtaButton, FieldWrapper, ErrorWrapper } })
export default class ButtonsRow extends mixins(RowValidationMixin) {
  @Prop({ type: Array as () => SelectItem[] })
  readonly list!: SelectItem[];
  @Prop(Boolean)
  readonly getModelNamesFromList!: boolean;
  @Prop(Boolean)
  readonly displayAsColumn!: boolean;
  @Prop(String)
  readonly name!: string;

  selectedOption: string = '';

  selected(value) {
    return value === this.selectedOption;
  }

  get options() {
    return this.list.map((v, i) => ({
      Title: v.Text,
      Link: '',
      ButtonStyle: CtaButtonStyle.Tertiary
    }));
  }

  click(value) {
    this.selectedOption = value;
    this.input(this.name, value, false);
  }
}
